import { render } from "./AppFrontAccordion.vue?vue&type=template&id=35351ba6&scoped=true"
import script from "./AppFrontAccordion.vue?vue&type=script&lang=js"
export * from "./AppFrontAccordion.vue?vue&type=script&lang=js"

import "./AppFrontAccordion.vue?vue&type=style&index=0&id=35351ba6&lang=scss&scoped=true"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35351ba6"]])

export default __exports__